import {makeStyles} from "@material-ui/core/styles";
import {Field, Form, Formik} from "formik";
import {Box, Button, Divider, Grid, TextField, Typography} from "@mui/material";
import React, {useEffect, useState} from "react";
import {uploadMedia} from "../../services/rating.service";
import {DropzoneDialog} from "material-ui-dropzone";
import LoaderBackDropWithPercentage from "../../components/LoaderWithBackDrop/LoaderBackDropWithPercentage.comp";
import {APP_STATUS, PAYMENT_STATUS} from "../../utils/constants";
import Container from "@material-ui/core/Container";
import LoaderWithBackDrop from "../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import InfoIcon from "@material-ui/icons/Info";
import StripePayment from "../../components/Stripe/StripePayment.comp";

const useStyles = makeStyles((theme) => ({
    container: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        // height:'95vh',
    },
    image: {
        height: '50vh',
        objectFit: 'contain',
    },
    instruction: {
        margin: theme.spacing(3, 3, 3, 0),
        color:'#ED6628',
    },
    button: {
        // marginBottom: theme.spacing(2),
        padding: theme.spacing(1, 3, 1, 3),
        fontSize: '15px',
        border: 'none',
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff',
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",        },

    },
    verticalDivider: {
        borderRight: `2px solid lightgrey`,
        height: '40vh',
        margin:'0 2% 0 0',
    },
    label: {
        textAlign: 'left',
        // marginRight: theme.spacing(2),
    },
    value: {
        textAlign: 'left',
        marginTop: theme.spacing(0.8),
        // marginLeft: theme.spacing(2),
    },
    cardContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'stretch',
        marginTop: theme.spacing(6),
    },
    card: {
        backgroundColor: "#F4F4F4",
        borderRadius: "30px",
        position:'relative',
        paddingBottom: '76px !important',
        flex: 1,
        padding: "15px !important",
        boxShadow: "6px 0px 20px rgba(0, 0, 0, 0.3)",
        margin:'0 25px',
        transition: "transform 0.2s ease-in-out",
        '&:hover': {
            transform: "scale(1.05)",
            cursor: "pointer",
        },
    },
    title: {
        background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
        color: 'transparent',
        backgroundClip: 'text',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        fontWeight: '500 !important',
        textAlign: 'center',
        fontSize: '45px !important',
    },
    button2: {
        marginTop: '16px !important',
        marginBottom: '16px !important',
        alignSelf: 'center',
        padding: theme.spacing(1, 3, 1, 3),
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff',
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",        },
    },
    badgeButton: {
        marginTop: '16px !important',
        marginBottom: '16px !important',
        alignSelf: 'center',
        background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",
        color: '#fff',
        '&:hover': {
            background: "linear-gradient(to bottom, #E7466E 35%, #FFAC46 190%) !important",        },
    },
}));

const BillingInfoForm = ({ onGetValues, initialValues, handleSaveBillingInfo, paymentAmount }) => {
    const classes = useStyles();
    console.log('initialValues', initialValues);
    // const formValuesRef = useRef(initialValues);
    //
    // useEffect(() => {
    //     onGetValues(formValuesRef.current);
    // }, [formValuesRef.current, onGetValues]);

    return (
        <>
            <Formik
                initialValues={initialValues}
                onSubmit={handleSaveBillingInfo}
                enableReinitialize
            >
                {({ values, handleChange, handleSubmit }) => {
                    onGetValues(values);

                    return (
                        <Form>
                            <Box>
                                <Typography component="h1" variant="h5" color="inherit" style={{ fontWeight: 'bold', background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
                                    color: 'transparent',
                                    backgroundClip: 'text',
                                    WebkitBackgroundClip: 'text',
                                    WebkitTextFillColor: 'transparent',}}>
                                    Billing Information
                                </Typography>
                                {/*<Divider sx={{ backgroundColor: '#ED6628', marginY: 2 }} />*/}
                                <br/>
                            </Box>

                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        label="Name of company"
                                        name="nameCompany"
                                        variant="outlined"
                                        fullWidth
                                        value={values.nameCompany}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Field
                                        as={TextField}
                                        label="Address of company"
                                        name="addressCompany"
                                        variant="outlined"
                                        fullWidth
                                        value={values.addressCompany}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Field
                                        as={TextField}
                                        label="Contact number of company"
                                        name="contactCompany"
                                        variant="outlined"
                                        fullWidth
                                        value={values.contactCompany}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Field
                                        as={TextField}
                                        label="Name of contact person"
                                        name="nameContactPerson"
                                        variant="outlined"
                                        fullWidth
                                        value={values.nameContactPerson}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Field
                                        as={TextField}
                                        label="Email of contact person"
                                        name="emailContactPerson"
                                        variant="outlined"
                                        fullWidth
                                        value={values.emailContactPerson}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={handleChange}
                                    />
                                </Grid>
                                <Grid item xs={12} md={6}>
                                    <Field
                                        as={TextField}
                                        label="Contact number of contact person"
                                        name="contactContactPerson"
                                        variant="outlined"
                                        fullWidth
                                        value={values.contactContactPerson}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={handleChange}
                                    />
                                </Grid>
                            </Grid>
                            { paymentAmount === '0' && (
                                <Box mt={2} style={{textAlign:'center'}}>
                                    <Button
                                        className={classes.button}
                                        type="button"
                                        onClick={handleSubmit}
                                        variant="contained"
                                        color="primary"
                                    >
                                        Save Billing Information
                                    </Button>
                                </Box>
                            )}
                        </Form>
                    );
                }}
            </Formik>
        </>
    );
}

function UploadPaymentProofFileDialogue(props) {

    const { openDialogue, dialogueCloseHandler, successCB } = props;

    const [uploading, setUploading] = useState(false);
    const [uploadProgress, setUploadProgress] = useState(0);

    const FileDialogueHandleSave = async (files) => {
        setUploading(true);
        const formData = new FormData();
        formData.append('media', files[0]);
        try {
            const result = await uploadMedia(formData,  progressEvent => {
                const uploadPercentage = Math.floor((progressEvent.loaded / progressEvent.total) * 99);
                setUploadProgress(uploadPercentage);
            })
            if(result.data) {
                const {media_path} = result.data;
                setUploadProgress(100);
                setTimeout(() => {
                    setUploading(false);
                    setUploadProgress(0);
                    successCB(media_path);
                }, 200);
            }
        }
        catch (e) {
            console.error("Error uploading file", e);
            dialogueCloseHandler();
        }
    }

    return (
        <>
            <DropzoneDialog
                open={openDialogue}
                onSave={FileDialogueHandleSave}
                acceptedFiles={['image/jpeg', 'image/png', 'image/bmp', '.pdf']}
                showPreviews={true}
                maxFileSize={5000000}
                filesLimit={1}
                onClose={dialogueCloseHandler}
            />
            {
                <LoaderBackDropWithPercentage
                    loading={uploading}
                    value={uploadProgress}
                />
            }
        </>
    );
}

function LabelValuePair(props) {

    const classes = useStyles();
    const {label, value} = props;

    return <Grid item xs={12}>
        <Grid container justify="center" alignItems="flex-start">
            <Grid item xs={6}>
                <Typography variant="h6" className={classes.label}>{label}</Typography>
            </Grid>
            <Grid item xs={6}>
                <Typography variant="body1" className={classes.value}>{value}</Typography>
            </Grid>
        </Grid>
    </Grid>
}


const ProgramUpgradeView = ({ data, actions, options }) => {
    const { application_id, openDialogue, appData, payment, paymentAmount, initialAmount
        , programPaymentStatus, paymentFetched, isBillingSaved, appliedPromoCode, companyInfo} = data;
    const { billingInfoSaveAction, applyPromoCodeAction, addFilePathToApplicationDataAction, handleRedirectDashboardAction } = actions;
    const { setOpenDialogue } = options;

    const [loading, setLoading] = useState(false);
    const classes = useStyles();

    const [promoCode, setPromoCode] = useState("");
    const [isApplyingPromo, setIsApplyingPromo] = useState(false);
    const [isPromoCodeApplied, setIsPromoCodeApplied] = useState(false);
    const [promoMessage, setPromoMessage] = useState("");
    const isPaymentSucceeded = payment && payment.status === PAYMENT_STATUS.SUCCESSFUL;
    const isPaymentProofUploaded = appData && appData.payment_proof_uploaded;

    const [billingInfo, setBillingInfo] = useState(companyInfo);

    useEffect(() => {
        setIsPromoCodeApplied(paymentAmount !== initialAmount);
    }, [initialAmount, paymentAmount]);

    const handleSaveBillingInfo = async () => {
        try {
            await billingInfoSaveAction(billingInfo);
            console.log("Billing info saved successfully.");
        } catch (error) {
            console.error("Failed to save billing info:", error);
            throw error;
        }
    };

    const handleApplyPromoCode = async () => {
        if (!promoCode.trim()) {
            setPromoMessage("Please enter a valid promo code.");
            return;
        }

        setIsApplyingPromo(true);
        setPromoMessage("");

        try {
            const response = await applyPromoCodeAction(application_id, promoCode.trim());
            if (!response?.error) {
                setIsPromoCodeApplied(true);
                setPromoMessage("Promo code applied successfully!");
            } else {
                setPromoMessage("Invalid promo code. Please try again.");
            }
        } catch (error) {
            setPromoMessage("Failed to apply promo code. Please try again later.");
        } finally {
            setIsApplyingPromo(false);
        }
    };

    useEffect(() => {
        if (isBillingSaved && programPaymentStatus === PAYMENT_STATUS.SUCCESSFUL) {
            handleRedirectDashboardAction();
        }
    }, [isBillingSaved])

    return (
        <Container className={classes.container}>
            <UploadPaymentProofFileDialogue
                openDialogue={openDialogue}
                dialogueCloseHandler={() => { setOpenDialogue(false) }}
                successCB={addFilePathToApplicationDataAction}
            />

            {loading && <LoaderWithBackDrop loading={loading} />}

            <>
                {isPaymentSucceeded ? (
                    <Container className={classes.container} component={'div'} style={{padding: 50}}>
                        <Box style={{
                            display:'flex',
                            flexDirection:'column',
                            alignItems:'center',
                            justifyContent:'center',
                            borderRadius: '16px',
                            backgroundColor: '#f9f9f9',
                            padding: '20px',
                            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',}}>
                            <Typography variant={"h4"} align={'center'} className={classes.title}>Payment Details</Typography>
                            <br/><br/>
                            <Grid container spacing={2} style={{color:'#ED6628', marginLeft:'20px !important'}} >
                                <LabelValuePair label={'Payment Status'} value={'Completed'}/>
                                <LabelValuePair label={'Payment Amount'} value={payment ? `${payment.currency.toUpperCase()} ${payment.amount}` : paymentAmount}/>
                                <LabelValuePair label={'Payment Time'} value={payment ? new Date(payment.updatedAt).toString() : ''}/>
                                <LabelValuePair label={'Payment By'} value={payment ? payment.updatedBy : ''}/>
                            </Grid>
                        </Box>
                        <Box marginTop={2}>
                            <Button className={classes.badgeButton} variant="contained" color="primary" sx={{ marginLeft: '16px' }}
                                    onClick={handleRedirectDashboardAction}>
                                Program Dashboard
                            </Button>
                        </Box>
                    </Container>
                ) : (
                    <>
                        {isPaymentProofUploaded || isPaymentSucceeded ? (
                            <Container className={classes.container}>
                                <Typography className={classes.instruction} variant="body1" align={'left'}>  <InfoIcon />  Payment verification in progress. You will receive an email upon completion, allowing you to upload program materials for alignment into this portal.
                                </Typography>
                                <Typography variant="h4" style={{ margin: '50px 20px', color:'#ED6628' }}>
                                    <strong style={{background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
                                        color: 'transparent',
                                        backgroundClip: 'text',fontSize: '35px !important',
                                        WebkitBackgroundClip: 'text',
                                        WebkitTextFillColor: 'transparent',}}>Amount Paid:  </strong> USD ${paymentAmount}

                                </Typography>
                                <Box textAlign={'center'}>
                                    <Button className={classes.button} variant="contained" color="primary"
                                            style={{ marginLeft: '10px', color:'white', borderRadius:'15px' }} href={appData.payment_proof_file_path} target="_blank" rel="noopener noreferrer">
                                        View Receipt
                                    </Button>
                                    {
                                        <Button variant="contained" color="primary"
                                                style={{marginLeft: '10px', color:'white', borderRadius:'15px'}}
                                                className={classes.button}
                                                onClick={() => setOpenDialogue(true)}>
                                            Re-upload Receipt
                                        </Button>
                                    }
                                </Box>
                            </Container>
                        ) : (
                            <Container className={classes.container} style={{padding:'0px'}}>
                                <Box sx={{
                                    display: 'flex',
                                    alignItems: 'stretch',
                                    justifyContent: 'center',
                                    flexDirection:'row',
                                    gap: 3,
                                    marginTop: 3,
                                    padding: '20px',
                                }}
                                >
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'stretch',
                                        justifyContent: 'center',
                                        flexDirection:'column',
                                        gap: 3,
                                        width:'65%',
                                        borderRadius: '16px',
                                        backgroundColor: '#f9f9f9',
                                        padding: '20px',
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                    }}>
                                        <Box
                                            sx={{
                                                flex: 1,
                                                padding: '20px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            <BillingInfoForm
                                                onGetValues={setBillingInfo}
                                                initialValues={companyInfo}
                                                handleSaveBillingInfo={handleSaveBillingInfo}
                                                paymentAmount={paymentAmount}
                                            />
                                        </Box>

                                        <Box
                                            sx={{
                                                flex: 1,
                                                padding: '20px',
                                                display: 'flex',
                                                flexDirection: 'column',
                                                justifyContent: 'center',
                                            }}
                                        >
                                            {process.env.REACT_APP_ONLINE_PAYMENTS === '1' && paymentFetched && (
                                                <>
                                                    <Typography
                                                        component="h1"
                                                        variant="h5"
                                                        sx={{
                                                            fontWeight: 'bold',
                                                            background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
                                                            color: 'transparent',
                                                            backgroundClip: 'text',
                                                            WebkitBackgroundClip: 'text',
                                                            WebkitTextFillColor: 'transparent',
                                                        }}
                                                    >
                                                        Payment
                                                    </Typography>
                                                    <Typography variant="body1" sx={{margin: '20px 0', color: '#5A5A5A'}}>
                                                        Payment Amount: <strong> USD ${paymentAmount}</strong>
                                                    </Typography>
                                                    { paymentAmount > 0 && (
                                                        <StripePayment {...data} handleSaveBillingInfo={handleSaveBillingInfo} isCreatorProgram={true} />
                                                    )}
                                                </>
                                            )}
                                        </Box>
                                    </Box>
                                    <Box
                                        sx={{
                                            flex: 1,
                                            padding: '20px',
                                            display: 'flex',
                                            width: '35%',
                                            flexDirection: 'column',
                                            justifyContent: 'flex-start',
                                            // alignItems: 'flex-start',
                                            backgroundColor: '#fff',
                                            borderRadius: '8px',
                                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                        }}
                                    >
                                        <Typography
                                            variant="h6"
                                            sx={{
                                                fontWeight: 'bold',
                                                background: 'linear-gradient(to right, #6A8EC9 10%, #8C74A7 35%, #D44C71 59%, #C91C6E 100%)',
                                                color: 'transparent',
                                                backgroundClip: 'text',
                                                WebkitBackgroundClip: 'text',
                                                WebkitTextFillColor: 'transparent',
                                                textAlign: 'center',
                                                marginBottom: 4,
                                                marginTop:'20px'
                                            }}
                                        >
                                            Order Summary
                                        </Typography>
                                        {isPromoCodeApplied && (
                                            <Typography
                                                variant="body1"
                                                sx={{
                                                    marginBottom: 1,
                                                    color: "#ED6628",
                                                    textDecoration: "line-through",
                                                }}
                                            >
                                                Original Amount: <strong>USD ${initialAmount}</strong>
                                            </Typography>
                                        )}
                                        <Typography variant="body1" sx={{marginBottom: 1, color: '#ED6628'}}>
                                            Subtotal Amount: <strong> USD ${paymentAmount}</strong>
                                        </Typography>
                                        { appliedPromoCode &&  <Typography variant="body1" sx={{marginBottom: 1, color: '#ED6628'}}>
                                            Promo-Code: <strong>{appliedPromoCode}</strong>
                                        </Typography>}

                                        <Box sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}>
                                            <TextField
                                                label="Promo Code"
                                                variant="outlined"
                                                fullWidth
                                                disabled={isPromoCodeApplied}
                                                value={promoCode}
                                                onChange={(e) => setPromoCode(e.target.value)}
                                                sx={{
                                                    "& .MuiOutlinedInput-root": {
                                                        "& fieldset": { borderColor: "#ED6628" },
                                                        "&:hover fieldset": { borderColor: "#ED6628" },
                                                        "&.Mui-focused fieldset": { borderColor: "#ED6628" },
                                                    },
                                                }}
                                            />
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={!promoCode.trim() || isApplyingPromo}
                                                onClick={handleApplyPromoCode}
                                                sx={{
                                                    backgroundColor: isApplyingPromo || !promoCode.trim() ? "grey" : "#ED6628",
                                                    "&:hover": { backgroundColor: isApplyingPromo || !promoCode.trim() ? "grey" : "#ED6628" },
                                                }}
                                            >
                                                {isApplyingPromo ? "Applying..." : "Apply"}
                                            </Button>
                                        </Box>
                                        {promoMessage && (
                                            <Typography
                                                variant="body2"
                                                sx={{
                                                    color: promoMessage.includes("successfully") ? "green" : "red",
                                                    marginBottom: 2,
                                                }}
                                            >
                                                {promoMessage}
                                            </Typography>
                                        )}
                                        <Divider sx={{width: '100%', marginY: 2}}/>
                                        <Typography
                                            variant="body1"
                                            sx={{
                                                fontWeight: 'bold',
                                                color: '#5A5A5A',
                                            }}
                                        >
                                            Total Amount: <strong> USD ${paymentAmount}</strong>
                                        </Typography>
                                    </Box>
                                </Box>
                            </Container>
                        )}
                    </>
                )}
            </>
        </Container>
    );
};

export default ProgramUpgradeView;